import { RR_PROGRESSBAR_TYPE } from './progressbar-type.enum';

export class RRProgressbarModel {
  animate: boolean;
  value: number;
  max: number;
  type: RR_PROGRESSBAR_TYPE;
  extraInfo: string;
}
